import {
  analysisService,
  queryClientOptions,
  shiftService,
  weeklyScheduleService
} from '@libs/data-access/queries'
import { Badge, defineModal, Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { FlipperFlagCondition } from '@spa/features'
import { QueryRequestStatus } from '@spa/features/Queries'
import type { FC } from 'react'
import React from 'react'

import { ShiftFormContainer } from '../../Forms/ShiftForm/ShiftFormContainer'
import { ShiftFormLegacy } from '../../Forms/ShiftForm/ShiftFormLegacy'

type EditShiftModalProps = {
  shiftId: number
  weeklyscheduleId: number
  onSuccess?: () => void
}

export const editShiftModalDef = defineModal<EditShiftModalProps>({
  name: 'editShiftModal'
})

const EditShiftModal: FC = () => {
  const { close, isOpen, data } = editShiftModalDef.useModal()
  const { t } = usePlanningFormTranslation()
  const weeklyScheduleQuery = weeklyScheduleService.api.useFetchOne(
    {
      pathParams: { id: data?.weeklyscheduleId },
      queryParams: { with_permissions: false }
    },
    { staleTime: queryClientOptions.time.STATIC }
  )

  if (!weeklyScheduleQuery.isSuccess || !data?.weeklyscheduleId) {
    return (
      <QueryRequestStatus
        status={weeklyScheduleQuery.status}
        error={weeklyScheduleQuery.error}
      />
    )
  }

  const { published: weeklyScheduleIsPublished } = weeklyScheduleQuery.data

  return (
    <Modal
      opened={isOpen}
      onClose={close}
      variant='right'
      data-testid='edit-shift-modal'
    >
      <Modal.Header
        title={t('shiftForm.modifyTitle')}
        desc={
          <Badge
            variant='light'
            color='semantic.blue'
            size='s'
            label={
              weeklyScheduleIsPublished
                ? t('shiftForm.publishedPlanning')
                : t('shiftForm.unpublishedPlanning')
            }
          />
        }
      />
      <FlipperFlagCondition
        flag='scheduling_burning_redux'
        active={
          <ShiftFormContainer
            onFormSuccess={() => {
              data?.onSuccess?.()
              analysisService.invalidateFetch()
              shiftService.unassigned.invalidateAllUnassigned()
              close()
            }}
            shiftId={data?.shiftId}
            weeklyscheduleId={data.weeklyscheduleId}
          />
        }
        inactive={
          <ShiftFormLegacy
            onFormSuccess={() => {
              data?.onSuccess?.()
              analysisService.invalidateFetch()
              shiftService.unassigned.invalidateAllUnassigned()
              close()
            }}
            shiftId={data?.shiftId}
            weeklyscheduleId={data.weeklyscheduleId}
          />
        }
      />
    </Modal>
  )
}

export default editShiftModalDef.withModalShow(EditShiftModal)
